// const API_BASE_URL = 'http://localhost/api'
// const STORAGE_BASE_URL = 'http://localhost/storage'
const API_BASE_URL = '/back/public/api'
const STORAGE_BASE_URL = '/back/public/storage'
export { API_BASE_URL }
export { STORAGE_BASE_URL }
